import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Inject, Optional } from '@angular/core';

import { GRID_CONFIG, GridConfig } from '@frontend/sports/grid/core/feature/config';

import { GridScoreboardBaseComponent } from '../scoreboard-base/grid-scoreboard-base.component';
import { DartsScoreboardHeaderComponent } from './darts-scoreboard-header.component';
import { SetGameScoreboardHeaderComponent } from './set-game-scoreboard-header.component';
import { SnookerScoreboardHeaderComponent } from './snooker-scoreboard-header.component';

@Component({
    selector: 'ms-grid-scoreboard-header',
    templateUrl: './grid-scoreboard-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, SetGameScoreboardHeaderComponent, SnookerScoreboardHeaderComponent, DartsScoreboardHeaderComponent],
})
export class GridEventScoreboardHeaderComponent extends GridScoreboardBaseComponent {
    @HostBinding('class') className = 'grid-event-scoreboard-header';
    constructor(@Optional() @Inject(GRID_CONFIG) gridConfig: GridConfig | null) {
        super(gridConfig);
    }
}
